// TOEFL iBT Mock 7 — Speaking (2026 format, advanced difficulty)
//
// 1. Listen and Repeat  – hear a sentence once, then repeat it exactly.
//                         Sentences grow longer and use academic vocabulary,
//                         passive voice, relative clauses and conditionals.
// 2. Take an Interview  – answer four questions, 45 seconds each, no prep time.
//                         Each question has two parts; `parts` lists words that
//                         show each part was answered (used by the scorer).

export const listenRepeat = {
  context:
    "You are starting work as a research assistant in a university laboratory. Listen to the lab manager's safety briefing and repeat exactly what you hear.",
  speakerGender: "m",
  sentences: [
    "Lab coats must be worn at all times.",
    "Samples should be labeled before they are stored.",
    "Never leave an experiment running without supervision.",
    "Any chemical spill, however small, must be reported immediately.",
    "The freezer in the corner is reserved for samples that are particularly sensitive to temperature.",
    "If the alarm sounds, switch off your equipment and leave by the nearest emergency exit.",
    "Had the previous team recorded their results more carefully, we would not have to repeat the entire study.",
  ],
};

export const interview = {
  context:
    "You have agreed to take part in a research study about how people decide what information to trust. A researcher will ask you four questions. Answer each question as fully as you can. You have 45 seconds for each answer.",
  speakerGender: "f",
  responseSeconds: 45,
  questions: [
    {
      text: "Thanks for coming in. To begin, think about the last time you came across a news story or claim that turned out to be false. How did you realise it was false, and what did you do afterwards?",
      keywords: ["news", "story", "claim", "false", "fake", "true", "realised", "realized", "noticed", "checked", "source", "sources", "article", "post", "website", "online", "social", "media", "shared", "friend"],
      parts: [
        ["realised", "realized", "noticed", "found out", "checked", "searched", "source", "sources", "compared", "seemed", "looked"],
        ["afterwards", "after that", "then", "deleted", "told", "warned", "stopped", "flagged", "unfollowed", "corrected", "now i", "since then", "decided"],
      ],
    },
    {
      text: "Some people argue that social media companies should be responsible for removing false information from their platforms. Others say this gives private companies too much control over public debate. Which view is closer to your own, and why?",
      keywords: ["social", "media", "companies", "company", "platform", "platforms", "remove", "removing", "false", "information", "control", "debate", "responsible", "freedom", "speech", "censor", "censorship", "agree", "disagree", "power"],
      parts: [
        ["i think", "i believe", "in my opinion", "i agree", "i disagree", "closer to", "my view", "i would say", "personally", "i side"],
        ["because", "since", "the reason", "for example", "for instance", "otherwise", "if they", "this means", "as a result"],
      ],
    },
    {
      text: "Experts often disagree with each other in public, for example about health or the economy. When experts disagree, how should ordinary people decide whom to believe? Can you give an example?",
      keywords: ["expert", "experts", "disagree", "believe", "trust", "evidence", "health", "economy", "scientist", "scientists", "doctor", "doctors", "research", "data", "consensus", "majority", "qualified", "decide"],
      parts: [
        ["should", "look at", "check", "evidence", "consensus", "majority", "qualifications", "qualified", "track record", "funding", "independent", "compare", "decide"],
        ["for example", "for instance", "such as", "during", "pandemic", "covid", "vaccine", "inflation", "diet", "climate", "when my", "i remember"],
      ],
    },
    {
      text: "Finally, imagine a school wants to teach students how to evaluate information online. What is the single most important skill it should teach, and how would you know whether the lesson had actually worked?",
      keywords: ["school", "students", "teach", "skill", "evaluate", "information", "online", "source", "sources", "check", "critical", "thinking", "lesson", "test", "measure", "worked", "effective", "evidence"],
      parts: [
        ["skill", "most important", "teach them", "should teach", "checking", "critical", "verify", "verifying", "sources", "lateral", "question"],
        ["know", "measure", "test", "assess", "worked", "success", "successful", "effective", "results", "afterwards", "compare", "survey", "task"],
      ],
    },
  ],
};
